<template>
  <div id="Traditional">
    <h1>Traditional season membership</h1>
    <div class="line"></div>
    <div class="wrapper">
      <img
        src="@/assets/images/traditional-map-2024-2.jpg"
        class="traditional-map"
        alt="Seating Map"
      />
      <img
        src="@/assets/images/Traditional-Pricing-Grid-2024-2.jpg"
        class="traditional-map"
        alt="Seating Map"
      />
      <div class="traditionalBreak">
        <h3>Traditional Membership Ticket Plans</h3>
      </div>
      <SeasonTicketPlans />

      <p class="smallPrint">*Same seats not guaranteed for Opening Day</p>
      <p class="smallPrint">
        *Please note, ticket plans, pricing and seating categories are subject
        to change each season
      </p>
      <div class="renewBtn">
        <a
          href="https://www.mlb.com/rays/tickets/season-tickets/season-membership/traditional-season-membership"
          target="_blank"
          class="btn btn-scondary"
        >
          Buy Now
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import SeasonTicketPlans from "@/components/sections/Schedule/SeasonTicketPlans";

export default {
  name: "Traditional",
  components: { SeasonTicketPlans },
  methods: {
    hideModaltoInvoiceTraditional() {
      this.$refs["my-modal-invoice-traditional"].show();
    },
  },
  created() {
    let userInfo = this.$store.state.global.userInfo;
    this.traditionalOrFlex = userInfo.Traditional_Flex;
  },
};
</script>

<style lang="scss" scoped>
#Traditional {
  padding-block: 150px 100px;
  background-image: url("~@/assets/images/bgImage_navy.jpg");
  background-size: cover;
  @media only screen and (max-width: $md) {
    padding-block: 50px;
  }
  .traditional-map {
    width: 100%;
    max-width: 1016px;
    margin: 0 auto;
  }
  .traditionalBreak {
    background-color: $dark-blue;
    text-align: center;
    max-width: 1024px;
    margin: 50px auto 0;
    padding: 11px;
    h3 {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      /* identical to box height */

      text-align: center;

      /* gray light */

      color: #dad9d7;
    }
  }
  h1 {
    font-family: "Antique Olive";
    font-style: normal;
    font-weight: 700;
    font-size: 35px;
    text-transform: uppercase;
    color: #79bde8;
    text-align: center;
    @media only screen and (max-width: $sm) {
      line-height: 1;
      font-size: 25px;
    }
  }
  .renewBtn {
    text-align: center;
    margin: 20px 0;
    &.yellow button {
      background: #ffd200;
      border: none;
      padding: 14px 40px;
    }
    button {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 145%;
      display: flex;
      align-items: center;
      text-align: center;
      text-transform: uppercase;
      color: #00285e;
      width: auto;
      margin-inline: auto;
      border-radius: 50px;
      padding: 10px 40px;
      margin-top: 50px;
      &:hover {
        text-decoration: none;
      }
      @media only screen and (max-width: $sm) {
        padding: 8px 4px;
      }
    }
  }
  .wrapper {
    padding: 0 10px;
  }
  .line {
    background-color: $yellow;
    width: 640px;
    height: 5px;
    margin: 15px auto 1em;
    @media only screen and (max-width: $md) {
      width: 80%;
    }
  }
  #seatingMap {
    max-width: 60%;
    height: auto;
    margin: 0 auto;
    @media only screen and (max-width: 1024px) {
      max-width: 70%;
    }
    @media only screen and (max-width: $md) {
      max-width: 80%;
    }
    @media only screen and (max-width: $sm) {
      max-width: 100%;
    }
  }

  .temp-text {
    max-width: 900px;
    margin: 70px auto;
    ul {
      color: #ffd200;
      font-family: "Antique Olive";
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 145%;
      text-align: center;
      list-style-position: inside;
      list-style: none;
      padding: 0;
      &:first-child {
        & > li {
          margin: 40px 0 0;
        }
      }
      & > ul {
        color: white;
        font-family: "Futura";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 145%;
        & > li {
          margin: 5px 0;
        }
      }
    }
  }
  p {
    font-family: "Futura";
    text-align: center;
    text-justify: inter-word;
  }
  p.smallPrint {
    font-family: "Futura";
    font-weight: 500;
    font-style: italic;
    font-size: 14px;
    line-height: 145%;
    color: #ffffff;
    margin-top: 20px;
  }
}
</style>
